import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DataSyncIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DataSync",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M8.93 15.3v-1.94a.4.4 0 0 1 .39-.36h16.01c.22 0 .39-.18.39-.39V9.5a.39.39 0 0 0-.39-.39H9.32a.39.39 0 0 1-.39-.39V6.76c0-.22-.19-.4-.41-.39a.36.36 0 0 0-.2.06l-6.15 3.96c-.18.12-.22.36-.1.53.03.04.06.08.1.1l6.13 4.6c.17.13.42.1.55-.08.05-.07.08-.15.08-.24m20.93 5.05-6.13-3.95a.393.393 0 0 0-.55.13.36.36 0 0 0-.06.2v2.02c0 .22-.18.39-.39.39l-15.44-.03a.39.39 0 0 0-.39.39v3.01c0 .22.18.39.39.39l15.42.05c.22 0 .39.18.39.39v1.88a.39.39 0 0 0 .63.31l6.13-4.6c.17-.13.2-.38.07-.55l-.06-.06Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 9.86H5.29a1.14 1.14 0 1 1 0-2.28h22.86a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m22.43 3 5.71 5.71-5.71 5.72z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22.43 15.57c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V3c0-.46.28-.88.71-1.06s.92-.08 1.25.25l5.71 5.71c.45.45.45 1.17 0 1.62l-5.71 5.71c-.22.22-.51.33-.81.33Zm1.14-9.81v5.91l2.95-2.95-2.95-2.95ZM8.71 16.71 3 22.43l5.71 5.71z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.71 29.29c-.3 0-.59-.12-.81-.33l-5.71-5.71a1.14 1.14 0 0 1 0-1.62l5.71-5.71c.33-.33.82-.43 1.25-.25s.71.59.71 1.06v11.43a1.154 1.154 0 0 1-1.15 1.15Zm-4.09-6.86 2.95 2.95v-5.91l-2.95 2.95Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.86 23.57H3a1.14 1.14 0 1 1 0-2.28h22.86a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
DataSyncIcon.displayName = 'DataSyncIcon';